<header>
	<nav>
    <div id="nav-items" class="wrapper">

      <div class="nav-item">
        <a routerLink="/" routerLinkActive="active" id="logo" (click)="switchToHomeView()"><img alt="" src="../../assets/siemens-healthineers-logo.jpg"></a>
      </div>

      <div class="nav-item nav-vendor">
        @if (supplier().companyName || supplier().supplierID) {
          <p class="vendor-title" id="company-name">
            <strong>
              {{ supplier().companyName }}
              @if (supplier().supplierID) {
                ({{ supplier().supplierID }})
              }
            </strong>
          </p>
        }
      </div>
      
    </div>
	</nav>
</header>
